import { css } from '@emotion/css';

const card = css`
  flex: 1;
  min-width: 30%;
  max-width: 280px;
  flex-wrap: wrap;
  border-radius: var(--radius-2);
  border: 1px solid var(--colors-neutral-300);
  padding: var(--spacings-4);
  display: flex;
  flex-direction: column;
  gap: var(--spacings-3);

  .rounded-full {
    width: var(--spacings-4);
    height: var(--spacings-4);
  }

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

const cardContent = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  & > .MuiBox-root:first-child {
    & .MuiTypography-root:first-child {
      color: var(--colors-neutral-400);
      font-weight: var(--text-weights-semi-bold);
    }

    & span {
      color: var(--colors-neutral-400);
    }
  }

  & > .MuiBox-root:last-child {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--spacings-0);

    & > div {
      margin: 0;
    }

    & > .MuiIconButton-root {
      padding: var(--spacings-0);
    }
  }
`;

const blockedBalance = css`
  padding: var(--spacings-0) var(--spacings-2);
  background-color: var(--colors-neutral-150);
  border: 1px solid var(--colors-neutral-400);
  border-radius: var(--radius-1);
  text-align: center;
  color: var(--colors-neutral-400);
`;

const exchangeContainer = css`
  display: flex;

  & > .MuiBox-root {
    flex: 1;
    display: flex;
    flex-direction: column;

    .MuiTypography-root {
      font-weight: var(--text-weights-semi-bold);
    }

    & .MuiTypography-root:first-child {
      color: var(--colors-neutral-400);
    }
  }
`;

const balanceTitle = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--spacings-1)',
});

const balanceAmount = css({
  color: 'var(--colors-neutral-400)',
});

const walletCardStyles = {
  card,
  cardContent,
  exchangeContainer,
  blockedBalance,
  balanceTitle,
  balanceAmount,
};

export default walletCardStyles;
